import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from '../services/http';

export const getAvailableOrders = async (data) => {
  const response = await getRequest({
    url: `exclusive-orders/`,
    token: data.token,
  });
  return response;
};

export const claimOrder = async (data) => {
  const response = await postRequest({
    url: `exclusive-orders/${data.reference}/claim/`,
    token: data.token,
  });
  return response;
};

export const getShopperOrders = async (data) => {
  const response = await getRequest({
    url: `shopper-orders/`,
    token: data.token,
  });
  return response;
};

export const getOrderDetail = async (data) => {
  const response = await getRequest({
    url: `shopper-orders/${data.orderId}/`,
    token: data.token,
  });
  return response;
};

export const nextOrderStatus = async (data) => {
  const response = await postRequest({
    url: `orders/${data.orderId}/next-status/?user_type=shopper`,
    data: {},
    token: data.token,
  });
  return response;
};

export const markProductAsTaken = async (data) => {
  const response = await postRequest({
    url: `orders/${data.orderId}/taken/${data.orderBranchProductId}/`,
    data: {
      storeBranchProduct: data.storeBranchProduct,
      quantity: data.quantity,
    },
    token: data.token,
  });
  return response;
};

export const deleteOrderProduct = async (data) => {
  const response = await deleteRequest({
    url: `orders/${data.orderId}/products/`,
    data: { order_branch_product: data.orderBranchProductId },
    token: data.token,
  });
  return response;
};

export const payOrder = async (data) => {
  const formData = new FormData();
  formData.append('total_value', data.total_value);
  formData.append('taxes', data.taxes);
  if (data.receipt) {
    formData.append('receipt', data.receipt);
  }

  const response = await postRequest({
    url: `orders/${data.orderId}/pay/`,
    data: formData,
    token: data.token,
  });
  return response;
};

export const uploadExtraReceipts = async (data) => {
  const response = await postRequest({
    url: `orders/${data.orderId}/receipt/`,
    data: { images: data.images },
    token: data.token,
  });
  return response;
};

export const assignShopperToOrder = async (data) => {
  const response = await postRequest({
    url: `exclusive-orders/${data.reference}/assign/${data.shopperId}/`,
    token: data.token,
  });
  return response;
};
